import React from "react";
import { Snackbar, Alert } from "@mui/material";

const TransactionAlert = ({ alertType, message, open, handleAlert }) => {
  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    handleAlert(false);
  };

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={6000} // Alert disappears after 6 seconds
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertType} variant="filled">
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default TransactionAlert;
